/* Deterministic company-display presets for "hidden identity" job listings.
   No AI involved — pure string templates, optionally adapted to the job's category. */

export const SECTOR_AWARE_KEYS = ["important_sector", "leader_sector", "recognized"];

export const PRESET_KEYS = [
  "important", "important_sector", "leader_sector", "recognized",
  "international", "multinational", "growing", "startup", "group", "consultancy", "other",
];

export function getSectorLabel(category, t) {
  if (!category) return "";
  const label = t(`categories.${category}`, "");
  return label || "";
}

export function getPresetLabel(key, category, t) {
  if (key === "other") return t("companyVisibility.presetOther");
  const sector = getSectorLabel(category, t);
  if (SECTOR_AWARE_KEYS.includes(key)) {
    return sector
      ? t(`companyVisibility.preset_${key}`).replace("{sector}", sector)
      : t(`companyVisibility.preset_${key}_generic`);
  }
  return t(`companyVisibility.preset_${key}`);
}

export function getAllPresetOptions(category, t) {
  return PRESET_KEYS.map((key) => ({ key, label: getPresetLabel(key, category, t) }));
}

export function sanitizeCustomLabel(text) {
  if (!text) return "";
  return text.replace(/<[^>]*>/g, "").trim().slice(0, 80);
}

/* Reverse-map an existing company_display_label back to a preset key, for edit prefill */
export function matchPresetFromLabel(label, category, t) {
  if (!label) return { preset: "important", custom: "" };
  for (const key of PRESET_KEYS) {
    if (key === "other") continue;
    if (getPresetLabel(key, category, t) === label) return { preset: key, custom: "" };
  }
  return { preset: "other", custom: label };
}
